"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.ShippingOfferDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _useShippingOffer = require("../../hooks/useShippingOffer");
var _logger = require("../../logger");
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _ShippingOfferSkeleton = require("../Skeleton/ShippingOfferSkeleton");
var _Buttons = require("./Buttons");
var _Item = require("./Item");
var _sharedStyles = require("./sharedStyles");
var _jsxRuntime = require("react/jsx-runtime");
const ContentWrapper = (0, _mui.styled)('div')({
    alignItems: 'end',
    display: 'grid',
    gridTemplateRows: 'minmax(0, auto) 1fr',
    minHeight: 0,
    height: 'fit-content'
});
const EmptyOffersWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.grey[400]
    };
});
const Items = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return (0, _sharedStyles.gridStyles)(theme);
});
const ShippingOfferDialog = (param)=>{
    let { deliveryChannelId, isOpen, onClose } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { buttonsProps, isLoading, items, toggleItem } = (0, _useShippingOffer.useShippingOffer)(deliveryChannelId, onClose);
    const { formatMessage } = (0, _hooks.useTranslations)();
    (0, _logger.logDebug)('Rendering ShippingOfferDialog.tsx.');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Dialog, {
        closeAfterTransition: true,
        fullWidth: true,
        header: formatMessage('getShippingForFree'),
        "aria-label": formatMessage('getShippingForFree'),
        open: isOpen,
        maxWidth: "785px",
        size: "small",
        footer: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Buttons.Buttons, {
            ...buttonsProps
        }),
        onClose: onClose,
        ...getTestIdProps(_models.TestId.ShippingOfferModal),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ContentWrapper, {
            ...getTestIdProps(_models.TestId.ShippingOfferModalContent),
            children: [
                isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ShippingOfferSkeleton.ShippingOfferSkeleton, {}) : null,
                !isLoading && items.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Items, {
                    children: items.map((item)=>{
                        const { productCode } = item;
                        const itemProps = {
                            onToggleItem: ()=>toggleItem(productCode),
                            ...item
                        };
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Item.Item, {
                            ...itemProps
                        }, productCode);
                    })
                }),
                !isLoading && items.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyOffersWrapper, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        ...getTestIdProps(_models.TestId.EmptyShippingOffersText),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                            id: "noShippingOffersAvailable"
                        })
                    })
                })
            ]
        })
    });
};
exports.ShippingOfferDialog = ShippingOfferDialog;
var _default = exports.default = ShippingOfferDialog;
